<template>
<div class="chapter">
<div class="inner_page">
<section class="epigraph" epub:type="epigraph">
<blockquote class="hanging_indent bq">
<p class=" firstInSection">Now’s the time to drink,</p>
<p>now’s the time to strike the earth with freedom’s foot,</p>
<p>now’s the time to deck the couch of the gods</p>
<p>with the banquets of the dancing priests,</p>
<p>my friends.</p>
<p>Before this it was a forbidden thing</p>
<p>to draw the Caecuban wine</p>
<p>from our grandfathers’ cellars,</p>
<p>while the mad queen was preparing</p>
<p>ruin and destruction</p>
<p>for the Capitol and the empire</p>
<p>With her flock of freaks and perverts,</p>
<p>frenzied enough to dream of victory,</p>
<p>and drunk on sweet good fortune.</p>
<p>But the escape of scarce one ship from the flames</p>
<p>moderated her rage,</p>
<p>and Caesar brought her mind,</p>
<p>mad drunk with wine of Mareotis,</p>
<p>under the power of true fear—</p>
<p>Driving her with ships in close pursuit</p>
<p>as she flew from Italy,</p>
<p>as the hawk pursues the tender dove</p>
<p>or the swift hunter the hare</p>
<p>in Haemonia’s wintry fields—</p>
<p>that he would lead in chains</p>
<p>That prodigy of fate.</p>
<p>She, seeking a more noble death,</p>
<p>did not in womanly wise fear the sword,</p>
<p>nor seek hidden shores with her swift fleet.</p>
<p>And she, bold woman, looked even on her fallen palace</p>
<p>with serene face, and bravely took in her hands</p>
<p>the savage serpents,</p>
<p>to drink deep their black poison.</p>
<p>Fiercely she resolved to die,</p>
<p>loathing to be borne in cruel Liburnian galleys,</p>
<p>loathing to be led, cast down from her throne,</p>
<p>in a Roman’s haughty triumph—</p>
<p>no humble woman, she.</p>
</blockquote>
<p class="right firstInSection">—Horace, <em>Odes I.xxxvii</em></p>
<p class="right">(trans. by Judith Tarr)</p>
<hr/>
<blockquote class="hanging_indent bq">
<p class=" firstInSection">Nunc est bibendum, nunc pede libero</p>
<p>pulsanda tellus, nunc Saliaribus</p>
<p>ornare pulvinar deorum</p>
<p>tempus erat dapibus, sodales.</p>
<p>Antehac nefas depromere Caecubum</p>
<p>cellis avitis, dum Capitolio</p>
<p>regina dementis ruinas</p>
<p>funus et imperio parabat</p>
<p>Contaminato cum grege turpium</p>
<p>morbo virorum, quidlibet impotens</p>
<p>sperare fortunaque dulci</p>
<p>ebria. Sed minuit furorem</p>
<p>Vix una sospes navis ab ignibus,</p>
<p>mentemque lymphatam Mareotico</p>
<p>redegit in veros timores</p>
<p>Caesar, ab Italia volantem</p>
<p>Remis adurgens, accipiter velut</p>
<p>mollis columbas aut leporem citus</p>
<p>venator in campis nivalis</p>
<p>Haemoniae, daret ut catenis</p>
<p>Fatale monstrum. Quae generosius</p>
<p>perire quaerens nec muliebriter</p>
<p>expavit ensem nec latentis</p>
<p>classe cita reparavit oras.</p>
<p>Ausa et iacentem visere regiam</p>
<p>voltu sereno, fortis et asperas</p>
<p>tractare serpentes, ut atrum</p>
<p>corpore combiberet venenum,</p>
<p>Deliberata morte ferocior,</p>
<p>saevis Liburnis scilicet invidens</p>
<p>privata deduci superbo</p>
<p>non humilis mulier triumpho.</p>
</blockquote>
<p class="right firstInSection">—Horace, <em>Odes I.xxxvii</em></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?ac6c3da8